<template>
  <v-app>
    <CommonAppHeader />
    <v-main>
      <slot />
    </v-main>
    <CommonAppFooter />
  </v-app>
</template>
